<template>
    <div ref="loginOrRegisterModal" class="text-white booking-modal fixed w-full h-full top-0 left-0 flex items-center justify-center">
        <div class="modal-overlay absolute w-full h-full bg-gray-900 opacity-50" @click="$emit('close')"></div>

        <div class="modal-container modal-bg-dark  md:max-w-4xl mx-auto rounded shadow-lg z-50 overflow-y-auto">

            <div class="modal-close absolute top-0 right-0 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm z-50">
                <span class="text-sm"></span>
            </div>

            <div class="modal-content py-4 text-left px-6">
                <div class="flex justify-end items-center pb-3">
                    <div class="modal-close cursor-pointer z-50" @click="$emit('close')">
                        <svg class="fill-current text-gray-600" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                            <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
                        </svg>
                    </div>
                </div>
                <div>
                    <div>
                        Du måste logga in eller registrera dig för att slutföra bokningen.
                        <div class="flex mt-3">
                            <div class="flex-1 flex justify-around">
                                <a class="btn" href="/login">Logga in</a>
                            </div>
                            <div class="flex-1 flex justify-around">
                                <a class="btn" :href="registerRoute">Registrera dig</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ModalLoginOrRegister",
        props: {
            company: {

            }
        },
        computed: {
            registerRoute() {
                return '/register' + (this.company ? '/' + this.company.id : '');
            }
        }
    }
</script>

<style scoped>

</style>